import { mainApi } from '../../../../api/mainApi';

import { middlewareApi } from '../../../middleware/middlewareApi';

import { AccessState } from '../../../../types';
import { StudentAvailable } from '../interfaces/studentAvailable.interfaces';
// import { AssignCoursesResponse } from '../interfaces/AssignCourses.interfaces';
import { AssingCoursesPostgradeResponse } from '../interfaces/CoursesByStudent.interfaces';

export const AssignCourses = middlewareApi.enhanceEndpoints({
  addTagTypes: ['AssignCourses'],
});
// Define a service using a base URL and expected endpoints
export const AssignCoursesApi = AssignCourses.injectEndpoints({
  // overrideExisting: false,

  endpoints: (builder) => ({
    /**
     * @GET student info
     */
    getStudentAvailable: builder.query<
      StudentAvailable,
      { offerDescription: string; identification: string }
    >({
      queryFn: async ({ offerDescription, identification }, { getState }) => {
        const {
          access: { currentProfile },
        } = getState() as { access: AccessState };

        const user_profile_id = currentProfile?.profileId;

        try {
          const { data } = await mainApi.get<StudentAvailable>(
            `/offers/${offerDescription}/students/${identification}/repproveds`,
            {
              params: {
                user_profile_id,
                offerDescription,
                identification,
              },
            }
          );

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      providesTags: (result, error) => [{ type: 'AssignCourses', id: 'student' }],
    }),

    /**
     * @GET courses by period availables
     */
    getCoursesByPeriod: builder.query<
      AssingCoursesPostgradeResponse[],
      {
        profileId?: number;
        offDescription: string;
        curriculumId: number;
        subjectId: number;
        coursePeriodId?: number;
      }
    >({
      queryFn: async (
        { profileId, offDescription, curriculumId, subjectId, coursePeriodId },
        { getState }
      ) => {
        const {
          access: { currentProfile },
        } = getState() as { access: AccessState };

        const user_profile_id = profileId || currentProfile?.profileId;

        try {
          const { data } = await mainApi.get<AssingCoursesPostgradeResponse[]>(
            `/offers/${offDescription}/curriculums/${curriculumId}/subjects/${subjectId}/periods`,
            {
              params: {
                user_profile_id,
                ...(coursePeriodId && { course_period_id: coursePeriodId }),
              },
            }
          );

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      providesTags: (result, error) => [{ type: 'AssignCourses', id: 'coursesByPeriod' }],
    }),

    //
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetStudentAvailableQuery,
  useGetCoursesByPeriodQuery,
  useLazyGetStudentAvailableQuery,
} = AssignCoursesApi;
